export const FETCH_STUDY_YEAR = "[StudyYear] Fetch Data";
